import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Redirect = ({ url }) => {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return <h5>Redirecting...</h5>;
};

Redirect.propTypes = {
  url: PropTypes.string.isRequired
};

export default Redirect;
